<template>
  <div class="users-list">
    <v-data-table
      :headers="headers"
      :items="members"
      :items-per-page="query.limit"
      :loading="loading"
      hide-default-footer>
      <!-- HEADER -->
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Invite Member</v-toolbar-title>
          <v-spacer />
          <v-btn
            color="secondary"
            :loading="saving"
            dark
            @click="openCreateInviteModal"
          >
            <v-icon left>
              mdi-plus
            </v-icon>
            Invite Member
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.inviteRef="{ item }">
        <div
          v-if="getStatusColor(item.status, item).status === 'pending'"
          class="text-center"
          @click="copyInvite(item.inviteRef)"
        >
          <p class="mb-0">
            {{ item.inviteRef }}
            <v-icon
              small
              class="ml-2"
            >
              mdi-content-copy
            </v-icon>
          </p>
        </div>
        <div v-else>
          -
        </div>
      </template>

      <!-- createdAt -->
      <template v-slot:item.createdAt="{ item }">
        {{ item.createdAt | dateUserFormat }}
      </template>

      <!-- email -->
      <template v-slot:item.email="{ item }">
        {{ item.email || '-' }}
      </template>

      <!-- tel -->
      <template v-slot:item.tel="{ item }">
        {{ item.tel || '-' }}
      </template>

      <!-- name -->
      <template v-slot:item.name="{ item }">
        {{ item.name || '-' }}
      </template>

      <!-- expiredAt -->
      <template v-slot:item.expiredAt="{ item }">
        {{ item.expiredAt | dateUserFormat }}
      </template>

      <!-- registeredAt -->
      <template v-slot:item.registeredAt="{ item }">
        {{ item.registeredAt | dateUserFormat }}
      </template>

      <!-- status -->
      <template v-slot:item.status="{ item }">
        <v-chip
          small
          dark
          :color="getStatusColor(item.status, item).color"
        >
          {{ getStatusColor(item.status, item).status.toUpperCase() }}
        </v-chip>
      </template>

      <!-- actions -->
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          color="error"
          small
          icon
          @click="openDeleteMemberModal(item.id)">
          <v-icon>
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-pagination
      v-model="query.page"
      :length="totalPage"
      :disabled="loading"
      color="secondary"
      total-visible="7" />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import DeliveryBookingProvider from '@/resources/DeliveryBookingProvider'
// import QRCode from 'qrcode'

export default {
  data () {
    return {
      deliveryBookingService: new DeliveryBookingProvider(),
      loading: false,
      saving: false,
      members: [],
      query: {
        page: 1,
        limit: 25,
        status: null,
        sortBy: 'createdAt',
        sortOrder: 'desc',
        search: ''
      },
      totalPage: 1,
      totalMembers: 0,
      headers: [
        {
          text: 'Invite Code.',
          value: 'inviteRef',
          sortable: false,
          width: '200',
          align: 'center'
        },
        {
          text: 'Email',
          value: 'memberId.email',
          sortable: false
        },
        {
          text: 'Name',
          value: 'memberId.name',
          sortable: false
        },
        {
          text: 'Tel',
          value: 'memberId.tel',
          sortable: false
        },
        {
          text: 'Created At',
          value: 'createdAt',
          sortable: false
        },
        {
          text: 'Expired At',
          value: 'expiredAt',
          sortable: false
        },
        {
          text: 'Registered At',
          value: 'registeredAt',
          sortable: false
        },
        {
          text: 'Status',
          value: 'status',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          align: 'center'
        }
      ],
      statusColors: {
        completed: 'green',
        pending: 'orange',
        deleted: 'red',
        expired: 'grey'
      }
    }
  },
  computed: {},
  mounted () {
    this.fetchMembers()
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Components/setSnackbar',
      setModal: 'Components/setModal'
    }),
    getStatusColor (status, item) {
      let calculatedStatus = status
      if (status === 'pending' && this.$dayjs(item.expiredAt).isBefore(this.$dayjs())) {
        calculatedStatus = 'expired'
      }
      return { color: this.statusColors[calculatedStatus] || 'grey', status: calculatedStatus }
    },
    copyInvite (id) {
      const message = `ขั้นตอนการเข้าใช้งาน Gentlewoman Warehouse Booking
1. เปิดลิงก์ต่อไปนี้ผ่านเบราว์เซอร์ของคุณ ${process.env.VUE_APP_DELIVERY_BOOKING_URL}
2. เข้าสู่ระบบด้วยไลน์
3. กรอกรหัสคำเชิญนี้ในหน้า Invite "${id}"
4. ดำเนินการลงทะเบียนให้เสร็จสิ้น`
      navigator.clipboard.writeText(message)
      this.setSnackbar({
        message: 'Copied invite link!',
        value: true,
        type: 'success'
      })
    },
    openCreateInviteModal () {
      this.setModal({
        value: true,
        title: 'Create Invite Link',
        message: 'Do you want to create a new invite link?',
        confirmText: 'Create',
        confirmType: 'success',
        cancelText: 'Cancel',
        onConfirm: async () => this.createInviteLink()
      })
    },
    async fetchMembers () {
      this.loading = true
      try {
        const { data } = await this.deliveryBookingService.getVendorMemberList({
          ...this.query,
          vendorId: this.$route.params.id
        })

        this.members = data.results
        this.totalPage = data.pages
        this.totalMembers = data.total
      } catch (error) {
        this.setSnackbar({
          message: error.message ? `${error.message}` : 'Get vendor member error',
          value: true,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    async createInviteLink () {
      try {
        this.saving = true
        const { data } = await this.deliveryBookingService.inviteMember(this.$route.params.id)
        this.copyInvite(data.inviteRef)
        this.fetchMembers()
      } catch (error) {
        this.setSnackbar({
          message: error.message ? `${error.message}` : 'Generate members invitational link error',
          value: true,
          type: 'error'
        })
      } finally {
        this.saving = false
      }
    },
    openDeleteMemberModal (memberId) {
      this.setModal({
        value: true,
        title: 'Delete Member',
        message: 'Do you want to delete ?',
        confirmText: 'DELETE',
        confirmType: 'error',
        cancelText: 'Cancel',
        onConfirm: async () => this.deleteMember(memberId)
      })
    },
    async deleteMember (memberId) {
      try {
        this.saving = true
        await this.deliveryBookingService.deleteMember(this.$route.params.id, memberId)
        this.fetchMembers()
      } catch (error) {
        this.setSnackbar({
          message: error.message ? `${error.message}` : 'Delete member error',
          value: true,
          type: 'error'
        })
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
